import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type MaterialExportResultFragment = { __typename: 'MaterialExportResult', outcome: Types.MaterialExportOutcome, job?: { __typename: 'Job', id: string, state: Types.JobState } | null, refusal?: { __typename: 'MaterialExportRefusal', reason: Types.MaterialExportRefusalReason, message: string } | null };

export type MaterialOutputsDeleteDataObjectMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type MaterialOutputsDeleteDataObjectMutation = { __typename: 'Mutation', deleteDataObject?: any | null };

export type MaterialOutputsDeleteJsonFileMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type MaterialOutputsDeleteJsonFileMutation = { __typename: 'Mutation', deleteJsonFile?: any | null };

export type MaterialOutputsCreateMaterialOutputMutationVariables = Types.Exact<{
  input: Types.MutationCreateMaterialOutputInput;
}>;


export type MaterialOutputsCreateMaterialOutputMutation = { __typename: 'Mutation', createMaterialOutput: { __typename: 'MaterialOutput', id: string } };

export type MaterialOutputsEnsurePconExportMutationVariables = Types.Exact<{
  materialId: Types.Scalars['ID']['input'];
}>;


export type MaterialOutputsEnsurePconExportMutation = { __typename: 'Mutation', ensurePconExport: { __typename: 'MaterialExportResult', outcome: Types.MaterialExportOutcome, job?: { __typename: 'Job', id: string, state: Types.JobState } | null, refusal?: { __typename: 'MaterialExportRefusal', reason: Types.MaterialExportRefusalReason, message: string } | null } };

export type MaterialOutputsEnsurePconExportBatchMutationVariables = Types.Exact<{
  materialIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type MaterialOutputsEnsurePconExportBatchMutation = { __typename: 'Mutation', ensurePconExportBatch: Array<{ __typename: 'MaterialExportBatchEntry', materialId: string, outcome: Types.MaterialExportOutcome, jobId?: string | null, message?: string | null }> };

export type MaterialOutputsEnsurePbrExportMutationVariables = Types.Exact<{
  materialId: Types.Scalars['ID']['input'];
  type: Types.PbrExportType;
  settings?: Types.InputMaybe<Types.PbrExportSettingsInput>;
}>;


export type MaterialOutputsEnsurePbrExportMutation = { __typename: 'Mutation', ensurePbrExport: { __typename: 'MaterialExportResult', outcome: Types.MaterialExportOutcome, job?: { __typename: 'Job', id: string, state: Types.JobState } | null, refusal?: { __typename: 'MaterialExportRefusal', reason: Types.MaterialExportRefusalReason, message: string } | null } };

export type MaterialOutputsEnsurePbrExportBatchMutationVariables = Types.Exact<{
  materialIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  type: Types.PbrExportType;
}>;


export type MaterialOutputsEnsurePbrExportBatchMutation = { __typename: 'Mutation', ensurePbrExportBatch: Array<{ __typename: 'MaterialExportBatchEntry', materialId: string, outcome: Types.MaterialExportOutcome, jobId?: string | null, message?: string | null }> };

export type MaterialOutputsCancelJobMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type MaterialOutputsCancelJobMutation = { __typename: 'Mutation', cancelJob: { __typename: 'Job', id: string } };

export type MaterialOutputsRestartJobMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type MaterialOutputsRestartJobMutation = { __typename: 'Mutation', restartJob: { __typename: 'Job', id: string } };

export type MaterialOutputsDeleteOutputMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type MaterialOutputsDeleteOutputMutation = { __typename: 'Mutation', deleteMaterialOutput?: any | null };

export const MaterialExportResultFragmentDoc = gql`
    fragment MaterialExportResult on MaterialExportResult {
  outcome
  job {
    id
    state
  }
  refusal {
    reason
    message
  }
}
    `;
export const MaterialOutputsDeleteDataObjectDocument = gql`
    mutation materialOutputsDeleteDataObject($id: ID!) {
  deleteDataObject(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialOutputsDeleteDataObjectGQL extends Apollo.Mutation<MaterialOutputsDeleteDataObjectMutation, MaterialOutputsDeleteDataObjectMutationVariables> {
    override document = MaterialOutputsDeleteDataObjectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MaterialOutputsDeleteJsonFileDocument = gql`
    mutation materialOutputsDeleteJsonFile($id: ID!) {
  deleteJsonFile(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialOutputsDeleteJsonFileGQL extends Apollo.Mutation<MaterialOutputsDeleteJsonFileMutation, MaterialOutputsDeleteJsonFileMutationVariables> {
    override document = MaterialOutputsDeleteJsonFileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MaterialOutputsCreateMaterialOutputDocument = gql`
    mutation materialOutputsCreateMaterialOutput($input: MutationCreateMaterialOutputInput!) {
  createMaterialOutput(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialOutputsCreateMaterialOutputGQL extends Apollo.Mutation<MaterialOutputsCreateMaterialOutputMutation, MaterialOutputsCreateMaterialOutputMutationVariables> {
    override document = MaterialOutputsCreateMaterialOutputDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MaterialOutputsEnsurePconExportDocument = gql`
    mutation materialOutputsEnsurePconExport($materialId: ID!) {
  ensurePconExport(materialId: $materialId) {
    ...MaterialExportResult
  }
}
    ${MaterialExportResultFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialOutputsEnsurePconExportGQL extends Apollo.Mutation<MaterialOutputsEnsurePconExportMutation, MaterialOutputsEnsurePconExportMutationVariables> {
    override document = MaterialOutputsEnsurePconExportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MaterialOutputsEnsurePconExportBatchDocument = gql`
    mutation materialOutputsEnsurePconExportBatch($materialIds: [ID!]!) {
  ensurePconExportBatch(input: {materialIds: $materialIds}) {
    materialId
    outcome
    jobId
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialOutputsEnsurePconExportBatchGQL extends Apollo.Mutation<MaterialOutputsEnsurePconExportBatchMutation, MaterialOutputsEnsurePconExportBatchMutationVariables> {
    override document = MaterialOutputsEnsurePconExportBatchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MaterialOutputsEnsurePbrExportDocument = gql`
    mutation materialOutputsEnsurePbrExport($materialId: ID!, $type: PbrExportType!, $settings: PbrExportSettingsInput) {
  ensurePbrExport(materialId: $materialId, type: $type, settings: $settings) {
    ...MaterialExportResult
  }
}
    ${MaterialExportResultFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialOutputsEnsurePbrExportGQL extends Apollo.Mutation<MaterialOutputsEnsurePbrExportMutation, MaterialOutputsEnsurePbrExportMutationVariables> {
    override document = MaterialOutputsEnsurePbrExportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MaterialOutputsEnsurePbrExportBatchDocument = gql`
    mutation materialOutputsEnsurePbrExportBatch($materialIds: [ID!]!, $type: PbrExportType!) {
  ensurePbrExportBatch(input: {materialIds: $materialIds, type: $type}) {
    materialId
    outcome
    jobId
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialOutputsEnsurePbrExportBatchGQL extends Apollo.Mutation<MaterialOutputsEnsurePbrExportBatchMutation, MaterialOutputsEnsurePbrExportBatchMutationVariables> {
    override document = MaterialOutputsEnsurePbrExportBatchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MaterialOutputsCancelJobDocument = gql`
    mutation materialOutputsCancelJob($id: ID!) {
  cancelJob(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialOutputsCancelJobGQL extends Apollo.Mutation<MaterialOutputsCancelJobMutation, MaterialOutputsCancelJobMutationVariables> {
    override document = MaterialOutputsCancelJobDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MaterialOutputsRestartJobDocument = gql`
    mutation materialOutputsRestartJob($id: ID!) {
  restartJob(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialOutputsRestartJobGQL extends Apollo.Mutation<MaterialOutputsRestartJobMutation, MaterialOutputsRestartJobMutationVariables> {
    override document = MaterialOutputsRestartJobDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MaterialOutputsDeleteOutputDocument = gql`
    mutation materialOutputsDeleteOutput($id: ID!) {
  deleteMaterialOutput(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialOutputsDeleteOutputGQL extends Apollo.Mutation<MaterialOutputsDeleteOutputMutation, MaterialOutputsDeleteOutputMutationVariables> {
    override document = MaterialOutputsDeleteOutputDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }